var _circle, _path, _path2, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#2D3F5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6631 47.9685V44.6085L50.5191 35.8245C51.2871 35.1418 51.8204 34.4965 52.1191 33.8885C52.4178 33.2805 52.5671 32.6938 52.5671 32.1285C52.5671 31.3605 52.4018 30.6778 52.0711 30.0805C51.7404 29.4725 51.2818 28.9925 50.6951 28.6405C50.1191 28.2885 49.4524 28.1125 48.6951 28.1125C47.8951 28.1125 47.1858 28.2991 46.5671 28.6725C45.9591 29.0351 45.4844 29.5205 45.1431 30.1285C44.8018 30.7365 44.6418 31.3925 44.6631 32.0965H40.6951C40.6951 30.5605 41.0364 29.2218 41.7191 28.0805C42.4124 26.9391 43.3618 26.0538 44.5671 25.4245C45.7831 24.7951 47.1858 24.4805 48.7751 24.4805C50.2471 24.4805 51.5698 24.8111 52.7431 25.4725C53.9164 26.1231 54.8391 27.0298 55.5111 28.1925C56.1831 29.3445 56.5191 30.6725 56.5191 32.1765C56.5191 33.2751 56.3698 34.1978 56.0711 34.9445C55.7724 35.6911 55.3244 36.3791 54.7271 37.0085C54.1404 37.6378 53.4098 38.3365 52.5351 39.1045L45.5431 45.2965L45.1911 44.3365H56.5191V47.9685H40.6631Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5282 48.4805C26.8962 48.4805 25.4562 48.1338 24.2082 47.4405C22.9602 46.7365 21.9842 45.7605 21.2802 44.5125C20.5869 43.2645 20.2402 41.8245 20.2402 40.1925V32.7685C20.2402 31.1365 20.5869 29.6965 21.2802 28.4485C21.9842 27.2005 22.9602 26.2298 24.2082 25.5365C25.4562 24.8325 26.8962 24.4805 28.5282 24.4805C30.1602 24.4805 31.5949 24.8325 32.8322 25.5365C34.0802 26.2298 35.0562 27.2005 35.7602 28.4485C36.4642 29.6965 36.8162 31.1365 36.8162 32.7685V40.1925C36.8162 41.8245 36.4642 43.2645 35.7602 44.5125C35.0562 45.7605 34.0802 46.7365 32.8322 47.4405C31.5949 48.1338 30.1602 48.4805 28.5282 48.4805ZM28.5282 44.8165C29.3389 44.8165 30.0749 44.6245 30.7362 44.2405C31.3976 43.8458 31.9202 43.3231 32.3042 42.6725C32.6882 42.0111 32.8802 41.2751 32.8802 40.4645V32.4805C32.8802 31.6591 32.6882 30.9231 32.3042 30.2725C31.9202 29.6111 31.3976 29.0885 30.7362 28.7045C30.0749 28.3098 29.3389 28.1125 28.5282 28.1125C27.7176 28.1125 26.9816 28.3098 26.3202 28.7045C25.6589 29.0885 25.1362 29.6111 24.7522 30.2725C24.3682 30.9231 24.1762 31.6591 24.1762 32.4805V40.4645C24.1762 41.2751 24.3682 42.0111 24.7522 42.6725C25.1362 43.3231 25.6589 43.8458 26.3202 44.2405C26.9816 44.6245 27.7176 44.8165 28.5282 44.8165Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3856_1779",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#661CE7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3856_1779)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 72,
    r: 21,
    fill: "white",
    fillOpacity: 0.24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/Step2.dc93a5b21e952eca327af68232c162ff.svg";
export { ForwardRef as ReactComponent };